import badgeBronze from "assets/images/bronze_badge.png";
import badgeGolden from "assets/images/golden_badge.png";
import badgePlatinum from "assets/images/platinum.png";
import badgeSilver from "assets/images/silver_badge.png";

const exports = {
  // Default tier badges (3 tiers: Bronze, Silver, Gold)
  tierBadges: [badgeBronze, badgeSilver, badgeGolden],
  // Legacy tier badges (4 tiers: includes Platinum)
  tierBadgesWithPlatinum: [badgeBronze, badgeSilver, badgeGolden, badgePlatinum],
  // Individual badge exports for flexibility
  badgeBronze,
  badgeSilver,
  badgeGolden,
  badgePlatinum,
};

export default exports;
